import { defineMessages } from 'react-intl-next';

export const modalFormMessages = defineMessages({
	modalTitle: {
		id: 'import-feedback.feedback-modal.title',
		defaultMessage: 'Give feedback on imported content',
		description: 'Title for the feedback modal',
	},

	dataFormatHelperText: {
		id: 'import-feedback.feedback-modal.data-format-helper-text',
		defaultMessage: 'Start typing to get a list of possible matches or press down to select.',
		description:
			'Helper text for data format select, located right below the data format select dropdown',
	},

	requiredFieldsAsterisk: {
		id: 'import-feedback.feedback-modal.required-fields-asterisk',
		defaultMessage: 'Required fields are marked with an asterisk',
		description: 'Explains that required feedback form fields are marked with an asterisk',
	},

	feedbackAppreciation: {
		id: 'import-feedback.feedback-modal.feedback-appreciation',
		defaultMessage: 'Your thoughts are valuable in helping improving our products.',
		description: 'Label encouraging users to provide feedback in the below form',
	},

	feedbackText: {
		id: 'import-feedback.feedback-modal.feedback-text',
		defaultMessage:
			'We’d love your feedback on how we can improved on imported content quality from {source}.',
		description:
			'Asks for feedback form and indicates the source of the imported content, located within the feedback form.',
	},
	dataFormatLabel: {
		id: 'import-feedback.feedback-modal.data-format-label',
		defaultMessage: 'Data format',
		description: 'Label for the dropdown menu to select which data format that needs improvement',
	},
	dataFormatClearControlLabel: {
		id: 'import-feedback.feedback-modal.data-format-clear-control-label',
		defaultMessage: 'Clear selected data format',
		description: 'Accessible text for the clear button in the dropdown menu',
	},
	tellUsAboutYourExperience: {
		id: 'import-feedback.feedback-modal.tell-us-about-your-experience',
		defaultMessage: 'Tell us about your experience',
		description: 'Label for the feedback form text area',
	},
	tellUsAboutYourExperiencePlaceholder: {
		id: 'import-feedback.feedback-modal.tell-us-about-your-experience-placeholder',
		defaultMessage: 'What did Confluence do well? What could be improved for imported content?',
		description: 'Placeholder text for the feedback form text area',
	},

	feedbackButton: {
		id: 'import-feedback.feedback-modal.feedback-button',
		defaultMessage: 'Send Feedback',
		description: 'Text for button to submit feedback the user has entered within the feedback form',
	},

	closeButton: {
		id: 'import-feedback.feedback-modal.close-button',
		defaultMessage: 'Close',
		description: 'Text for button to close the modal & feedback form',
	},
});
